<template>
  <div class="review-form">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <md-field title="活动点评">
          <md-field-item solid title="星级" :addon="star + '星'" arrow @click="changeStar()" />

        <ValidationProvider name="点评内容" rules="required|min:10" v-slot="{ errors }">
          <md-textarea-item
                  autosize
                  v-model="content"
                  placeholder="请输入你的点评内容"
                  :error="errors[0]"
          />
        </ValidationProvider>

        <ul class="image-reader-list">
          <li
                  class="image-reader-item"
                  v-for="(img, index) in imageList['reader0']"
                  :key="index"
                  :style="{
          'backgroundImage': `url(${img.local})`,
          'backgroundPosition': 'center center',
          'backgroundRepeat': 'no-repeat',
          'backgroundSize': 'cover'
        }">
            <md-tag
                    class="image-reader-item-del"
                    size="small"
                    shape="quarter"
                    fill-color="#111A34"
                    type="fill"
                    font-color="#fff"
                    @click.native="onDeleteImage('reader0', index)"
            >
              <md-icon name="close"></md-icon>
            </md-tag>
          </li>
          <li class="image-reader-item add">
            <md-image-reader
                    name="reader0"
                    @select="onReaderSelect"
                    @complete="onReaderComplete"
                    @error="onReaderError"
                    :is-multiple="false"
            ></md-image-reader>
            <md-icon name="camera" size="md" color="#CCC"></md-icon>
            <p>添加图片</p>
          </li>
        </ul>
        </md-field>

        <div class="btn-wrap">
          <md-button type="primary" native-type="submit">保存</md-button>
        </div>
      </form>
    </ValidationObserver>

    <!--<md-picker-->
            <!--ref="picker-qty"-->
            <!--v-model="starPickerShow"-->
            <!--:data="starData"-->
            <!--large-radius-->
            <!--@confirm="onPickerConfirm($event)"-->
            <!--title="选择星级"-->
    <!--&gt;</md-picker>-->
    <md-selector
            v-model="starPickerShow"
            default-value="5"
            :data="starData[0]"
            title="选择星级"
            large-radius
            @choose="onPickerConfirm"
    ></md-selector>
  </div>
</template>

<script>
import { Field, FieldItem,TextareaItem,Button,Icon,ImageReader, Tag,Selector } from 'mand-mobile'
//import imageProcessor from 'mand-mobile/lib/image-reader/image-processor'
import { ValidationProvider,ValidationObserver,extend } from 'vee-validate';
import { required,min } from 'vee-validate/dist/rules';
import Payment from '../components/Payment.vue';


extend('required', required);
extend('min', min);

export default {
  name: "ReviewForm",
  components: {
      [Field.name]: Field,
      [FieldItem.name]: FieldItem,
      [TextareaItem.name]: TextareaItem,
      [Button.name]: Button,
      [Icon.name]: Icon,
      [ImageReader.name]: ImageReader,
      [Tag.name]: Tag,
      [Selector.name]: Selector,
      ValidationProvider,ValidationObserver
  },
  props: [],
  data() {
      return {
          star: 5,
          starPickerShow: false,
          starData:[],
          content:'',
          imageList: {
              reader0: [],
              reader1: [],
          },
      }
  },
    mounted() {
        const starData = [];
        for(let i = 5;i>=1;i--) {
            starData.push({value:i,text:i+'星'})
        }
        this.starData = [starData];
    },
  methods: {
      changeStar() {
          this.starPickerShow = true;
      },
      onPickerConfirm({value}) {
//          const values = this.$refs['picker-qty'].getColumnValues();
          this.star = value;
      },
      onReaderSelect(name, {files}) {
          files.forEach(file => {
              console.log('[Mand Mobile] ImageReader Selected:', 'File Name ' + file.name)
          })
          this.$toast.loading('图片读取中...')
      },
      onReaderComplete(name, {dataUrl, file}) {
          this.$toast.hide()
          console.log('[Mand Mobile] ImageReader Complete:', 'File Name ' + file.name);
          const currentImage = this.imageList[name].length;
          console.log(currentImage);
          if(currentImage + 1 >= 9) {
              this.$toast.failed('最多只能上传9张图片');
              return false;
          }

          this.$toast.loading("上传中...");
          const formData = new FormData();
          formData.append('file', file);
          this.$http.post(`upload`, formData)
              .then(({data}) => {
                  this.$toast.hide();
                  const demoImageList = this.imageList[name] || [];
                  demoImageList.push({local:dataUrl,path:data.path});
                  this.$set(this.imageList, name, demoImageList)
              })
              .catch(({response}) => {
                  console.log(response);
              });

//          setTimeout(() => {
//              const demoImageList = this.imageList[name] || []
//              demoImageList.push({local:dataUrl,path:"xxx"});
//              this.$set(this.imageList, name, demoImageList)
//          }, 100)
      },
      onReaderError(name, {msg}) {
          this.$toast.failed(msg)
      },
      onDeleteImage(name, index) {
          const demoImageList = this.imageList[name] || []
          demoImageList.splice(index, 1)
          this.$set(this.imageList, name, demoImageList)
      },
      onSubmit() {
          const {enrollId} = this.$route.params;
          this.$toast.loading("提交中...");
          let postData = {content:this.content, star:this.star,images:[]};
          postData.images = this.imageList.reader0.map((image) => {
              return image.path;
          });
          this.$http.post(`enrolls/${enrollId}/reviews`, postData)
              .then(() => {
                  this.$toast.hide();
                  this.$toast.succeed("点评成功");
                  this.$router.back();
              })
              .catch(({response}) => {
                  console.log(response);
              })
      },
  }
};
</script>

<style lang="scss" scoped>
  .review-form {
    /*padding: 100px 20px 0;*/
  }
  .btn-wrap {padding: 30px;}
</style>

<style lang="stylus" scoped>
    .image-reader-list
      margin-top 30px
      float left
      width 100%
      .image-reader-item
        position relative
        float left
        width 23.5%
        padding-bottom 23.5%
        margin-bottom 2%
        margin-right 2%
        background #FFF
        box-shadow 0 5px 20px rgba(197, 202, 213, .25)
        box-sizing border-box
        list-style none
        border-radius 4px
        background-size cover
        overflow hidden
        &:nth-of-type(4n)
          margin-right 0
        &.add
          .md-icon
            position absolute
            top 40%
            left 50%
            transform translate(-50%, -50%)
            opacity .5
          p
            position absolute
            top 50%
            left 0
            width 100%
            margin-top 15px
            font-size 22px
            color #CCC
            text-align center
        .image-reader-item-del
          position absolute
          top 0
          right 0
          z-index 3
          opacity .8
          .md-icon-close
            font-size 24px
</style>
